import type { IdentityContextAttributes } from '@objectiv/plugin-identity-context';

const VARIANT_SEPARATOR = '___';
const KEY_VALUE_SEPARATOR = '---';

export const getFlagSetIdentityContext = (
  flagSetSource: string,
  ab: Record<string, unknown>,
): IdentityContextAttributes[] => {
  return [
    { id: 'flagSetSource', value: flagSetSource },
    {
      id: 'flagSet',
      value: Object.entries(ab)
        .map(([abTestName, group]) => {
          return `${abTestName}${KEY_VALUE_SEPARATOR}${group}`;
        })
        .join(VARIANT_SEPARATOR),
    },
  ];
};
